import clsx from 'clsx';
import { FC, HTMLAttributes, memo, useState } from 'react';
import SortBy from 'src/features/productList/components/SortBy/SortBy';
import { Flex } from 'src/shared/components/Flex';
import { useTranslation } from 'src/shared/utils/translation';
import { useIsMobile } from '~/shared/hooks/useIsMobile/useIsMobile';
import {
    StoreAvailabilityToggles,
    StoreAvailabilityDrawer,
} from '~/features/productList/components/StoreAvailability';
import styles from './HitsHeader.module.scss';

interface HitsHeaderProps extends HTMLAttributes<HTMLDivElement> {
    totalHits: number;
    /** Category and search listings get the online/in-store toggles; gift card listings don't. */
    showStoreAvailability?: boolean;
}

const HitsHeader: FC<HitsHeaderProps> = ({ totalHits, showStoreAvailability, ...rest }) => {
    const { translate } = useTranslation();
    const isMobile = useIsMobile();
    const [isStoreDrawerOpen, setIsStoreDrawerOpen] = useState(false);

    // Mobile has its own equivalent inside FilterDrawer's "PÅ LAGER" panel (StoreAvailabilityPanel).
    const showDesktopToggles = showStoreAvailability && !isMobile;

    return (
        <>
            <Flex alignItems="flex-start" justifyContent="space-between" {...rest}>
                <Flex alignItems="center" gap="medium">
                    <span className={clsx(styles.count, totalHits <= 0 && styles.hidden)}>
                        {totalHits} {translate('plp.products')}
                    </span>

                    {showDesktopToggles && (
                        <StoreAvailabilityToggles
                            onSelectStore={() => setIsStoreDrawerOpen(true)}
                        />
                    )}
                </Flex>

                <SortBy />
            </Flex>

            {showDesktopToggles && (
                <StoreAvailabilityDrawer
                    open={isStoreDrawerOpen}
                    onClose={() => setIsStoreDrawerOpen(false)}
                />
            )}
        </>
    );
};

export default memo(HitsHeader);
